var _defs, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _rect, _polygon, _polygon2, _polygon3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPattern06(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1696.47 824",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#efefef;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pattern06") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 6,
    cy: 773,
    r: 6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 29,
    cy: 761,
    r: 6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 52,
    cy: 748,
    r: 6
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 18,
    cy: 795,
    r: 6
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 41,
    cy: 783,
    r: 6
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 64,
    cy: 770,
    r: 6
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 30,
    cy: 818,
    r: 6
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 53,
    cy: 806,
    r: 6
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 76,
    cy: 793,
    r: 6
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 336.76,
    cy: 326.6,
    r: 5.91
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 362.21,
    cy: 324.45,
    r: 5.91
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 388.05,
    cy: 321.4,
    r: 5.91
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 339.29,
    cy: 351.15,
    r: 5.91
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 364.74,
    cy: 349,
    r: 5.91
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 390.58,
    cy: 345.94,
    r: 5.91
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 341.44,
    cy: 376.6,
    r: 5.91
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 366.89,
    cy: 374.45,
    r: 5.91
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 392.73,
    cy: 371.39,
    r: 5.91
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 919.96,
    cy: 91.8,
    r: 5.96,
    transform: "translate(96.41 640.39) rotate(-45)"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 945.01,
    cy: 97.41,
    r: 5.96,
    transform: "translate(552.78 966.95) rotate(-78.48)"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 970.77,
    cy: 102.3,
    r: 5.96,
    transform: "matrix(0.2, -0.98, 0.98, 0.2, 568.61, 996.11)"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 914.95,
    cy: 116.17,
    r: 5.96,
    transform: "translate(77.71 643.99) rotate(-45)"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 940,
    cy: 121.77,
    r: 5.96,
    transform: "translate(524.9 981.54) rotate(-78.48)"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 965.76,
    cy: 126.67,
    r: 5.96,
    transform: "translate(540.71 1010.7) rotate(-78.48)"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 909.29,
    cy: 141.3,
    r: 5.96,
    transform: "translate(58.29 647.35) rotate(-45)"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 934.34,
    cy: 146.9,
    r: 5.96,
    transform: "translate(495.75 996.1) rotate(-78.48)"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 960.11,
    cy: 151.8,
    r: 5.96,
    transform: "translate(511.57 1025.28) rotate(-78.48)"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 966.47,
    cy: 467,
    r: 9
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1329.47,
    cy: 400,
    r: 9
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 522.78,
    cy: 511.94,
    r: 19.5
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1681.47,
    cy: 798,
    r: 15
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 58,
    cy: 449,
    r: 9
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 626.97,
    cy: 4.5,
    r: 4.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1156.35,
    y: 241.03,
    width: 63.03,
    height: 35.46,
    rx: 17.64,
    ry: 17.64,
    transform: "translate(95.22 934.99) rotate(-48.21)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "208.54 44.36 240.9 59.99 272.12 42.2 267.25 77.8 293.81 102 258.45 108.37 243.65 141.11 226.66 109.44 190.95 105.48 215.81 79.54 208.54 44.36"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1644.59 334.81 1653.09 359.21 1678.01 366.04 1657.43 381.66 1658.63 407.47 1637.41 392.73 1613.24 401.85 1620.71 377.11 1604.57 356.94 1630.39 356.4 1644.59 334.81"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "816.08 722.84 786.99 708.78 758.91 724.78 763.29 692.76 739.4 671 771.2 665.27 784.51 635.82 799.79 664.31 831.91 667.87 809.54 691.19 816.08 722.84"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1411.23,599.9c-.7,1.77-1.21,3.61-2,5.35A124.2,124.2,0,0,1,1393.1,631a115.25,115.25,0,0,1-17.89,18.32c-.14.12-.29.22-.51.39A17.41,17.41,0,0,0,1362,638.76a44,44,0,0,1,2.93-4.35A132.91,132.91,0,0,1,1402,600.66a35.56,35.56,0,0,1,7.17-3.37h2Z",
    transform: "translate(-108.12 -37)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1338,672c-.14-.08-.16-.21,0-.27,2.88-1.39,4.22-4,5.39-6.74a12.9,12.9,0,0,0,1-4.42,10.58,10.58,0,1,1,13,11.16c-.33.09-.75-.11-1,.27Z",
    transform: "translate(-108.12 -37)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1360.32,641.58a14.19,14.19,0,0,1,11.42,9c.31.75.27,1.19-.5,1.62a31.63,31.63,0,0,1-4.53,2.33,13.83,13.83,0,0,0-8.89-6.47A23.2,23.2,0,0,1,1360.32,641.58Z",
    transform: "translate(-108.12 -37)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M427.11,763.27c.69,1.77,1.2,3.61,2,5.35a124.93,124.93,0,0,0,16.14,25.74,116,116,0,0,0,17.88,18.32l.52.38a17.41,17.41,0,0,1,12.71-10.93,41.86,41.86,0,0,0-2.94-4.35A132.77,132.77,0,0,0,436.33,764a36.37,36.37,0,0,0-7.17-3.37h-2.05Z",
    transform: "translate(-108.12 -37)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M500.31,835.35c.13-.08.16-.21,0-.28-2.87-1.38-4.21-4-5.38-6.74a12.81,12.81,0,0,1-1-4.42A10.57,10.57,0,1,0,481,835.08c.33.08.75-.11,1,.27Z",
    transform: "translate(-108.12 -37)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M478,805a14.16,14.16,0,0,0-11.42,9c-.31.74-.27,1.18.5,1.62a32.68,32.68,0,0,0,4.53,2.33,13.83,13.83,0,0,1,8.89-6.47A23.2,23.2,0,0,0,478,805Z",
    transform: "translate(-108.12 -37)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1538.38,117.69c.7,1.78,1.21,3.61,2,5.36a125.2,125.2,0,0,0,16.14,25.74,116,116,0,0,0,17.88,18.32l.51.38a17.46,17.46,0,0,1,12.72-10.94,44.1,44.1,0,0,0-2.94-4.35,132.88,132.88,0,0,0-37.08-33.75,36.64,36.64,0,0,0-7.17-3.37h-2.06Z",
    transform: "translate(-108.12 -37)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1611.59,189.78c.13-.09.16-.21,0-.28-2.87-1.39-4.21-4-5.38-6.74a12.81,12.81,0,0,1-1-4.42,10.58,10.58,0,1,0-13,11.17c.33.08.75-.11,1,.27Z",
    transform: "translate(-108.12 -37)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1589.29,159.37a14.2,14.2,0,0,0-11.42,9c-.3.75-.27,1.19.5,1.63a33.85,33.85,0,0,0,4.53,2.33,13.89,13.89,0,0,1,8.89-6.48A22.71,22.71,0,0,0,1589.29,159.37Z",
    transform: "translate(-108.12 -37)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern06);
export default __webpack_public_path__ + "static/media/pattern06.241c89e790594155b82635722562964a.svg";
export { ForwardRef as ReactComponent };